import { useQuery } from "@tanstack/react-query";
import { http } from "../../utils/httpCommon";
import { OldRoutesSchema } from "../../types/route.type";
import { useApiUrls } from "../useApiUrl";

const useRoutesKeys = {
  routes: (serviceCenterId: number) => ["routes", serviceCenterId],
  route: (serviceCenterId: number, routeId: number) => [
    "routes",
    serviceCenterId,
    routeId,
  ],
  validateZipCode: (serviceCenterId: number, zipCode: string) => [
    "routes",
    serviceCenterId,
    "zipcodes",
    zipCode,
  ],
};

export const useRoutesAndTrapsOld = (
  serviceCenterId: number,
  enabled = true
) => {
  const hookUrls = useApiUrls();
  const urls = hookUrls;

  const getRoutesAndTraps = async (sicId: number) => {
    const { data } = await http.get(urls.getRoutesAndTraps, {
      params: { sicId },
    });
    return OldRoutesSchema.parse(data);
  };
  return useQuery({
    enabled,
    queryKey: useRoutesKeys.routes(serviceCenterId),
    queryFn: () => getRoutesAndTraps(serviceCenterId),
  });
};
